module.exports = __webpack_public_path__ + "img/hfg_of110122_01k.ddf33a0a.jpg";